module.exports = "<span id=\"loader-spinner\" class=\"loading\"></span>\n<router-outlet></router-outlet>\n\n   \n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik.component.html
// module id = ./src/app/sainik.component.html
// module chunks = main